const styles = {
  container: {
    textTransform: 'none',
  },
} as any;

export default styles;
